import localforage from 'localforage'

class Operateur {
    static getOperateurOption(callback) {
        localforage
            .getItem('listOptions')
            // Handler d'erreur en 2e argument de .then() et non en .catch() :
            // un .catch() enchaine ici avalerait aussi les erreurs levees par
            // callback(), pas seulement l'echec de lecture du stockage.
            .then(options => {
                callback(JSON.parse(options))
            }, err => {
                console.error("Chargement des options operateur impossible (listOptions)", err)
            })
    }

    static getOperateurOptions() {
        return new Promise((resolve, reject) => {
            localforage
                .getItem('listOptions')
                .then(options => {
                    resolve(JSON.parse(options))
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
}

export default Operateur



// WEBPACK FOOTER //
// ./src/js/models/Operateur.js